import React, { useState, useRef, useCallback } from 'react';
import {pageSizes, actionColumns, filteringStateColumnExtensions} from '../../Config/constants';
import {
    FilteringState, GroupingState,
    IntegratedGrouping, IntegratedPaging, IntegratedSorting, IntegratedFiltering,
    PagingState, SortingState, DataTypeProvider, SelectionState
  } from '@devexpress/dx-react-grid';
  import {
    DragDropProvider,
    Grid, GroupingPanel, PagingPanel,
    Table, TableFilterRow, TableGroupRow,
    TableHeaderRow, Toolbar, ExportPanel
  } from '@devexpress/dx-react-grid-material-ui';
import { GridExporter } from '@devexpress/dx-react-grid-export';
import saveAs from 'file-saver';

export default function ApiDevexGrid(props) {
  const [grouping, setGrouping] = useState([]);
  const [selection, setSelection] = useState([]);
    let filteredColumns = props.columns.filter(c => c.shown === true);
    let gridcolumns = [...filteredColumns];

    if(props.hasActions){
        gridcolumns.push({ name: 'actions', title: 'Actions' });
    }

    const exporterRef = useRef(null);

    const startExport = useCallback(() => {
      exporterRef.current.exportGrid();
    }, [exporterRef]);

    const onSave = (workbook) => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
      });
    };
    const TableRow = ({ row, style, ...restProps }) => (

      <Table.Row
        {...restProps}
        style={{
          backgroundColor: row.enabled === false ? "#FFC7CE" : undefined,
          ...style
        }}
      />
    );

    const Root = props => <Grid.Root {...props} style={{ height: '100%' }} />;

        return <React.Fragment>
                  <Grid rows={props.data} columns={gridcolumns} rootComponent={Root}>
                    <FilteringState columnExtensions={filteringStateColumnExtensions}/>
                    <SortingState />                        
                    <GroupingState
                      defaultExpandedGroups={[]}
                      grouping={grouping}
                      onGroupingChange={setGrouping}
                    />
                    <PagingState />
                    <SelectionState selection={selection} onSelectionChange={setSelection} />
                    <IntegratedGrouping />
                    <IntegratedFiltering />
                    <IntegratedSorting />
                    <IntegratedPaging />
                    <DragDropProvider />
                    { props.hasActions ? <DataTypeProvider formatterComponent={props.ActionFormatter} for={actionColumns} /> : <React.Fragment></React.Fragment>}
                    <Table rowComponent={TableRow} />
                    <TableHeaderRow showSortingControls={true} />
                    <TableFilterRow showFilterSelector={true}/>
                    <Toolbar />
                    <GroupingPanel showSortingControls={true}/>
                    <TableGroupRow />
                    <PagingPanel pageSizes={pageSizes}/>
                    <ExportPanel startExport={startExport} />
                  </Grid> 
                  <GridExporter
                    ref={exporterRef}
                    rows={props.data}
                    columns={gridcolumns}
                    grouping={grouping}
                    selection={selection}
                    onSave={onSave}
                  />
                  </React.Fragment>
}